import Layout from "../layout";
import { extend } from "../utils/core";
import { EVENTS } from "./utils/constants";

class ExLayout extends Layout{
	constructor(settings, rendition){
		super(settings);

		//this._minSpreadWidth 預設值為"auto"
		this._minSpreadWidth = settings.minSpreadWidth;

		//是否為直書模式
		this._isVerticalMode = false;

		//是否為條漫
		this._isWebToon = settings.webToon;

		//加入rendition
		this._rendition = rendition;
	}

	/**
	 * Calculate the dimensions of the pagination
	 * @param  {number} _width  width of the rendering
	 * @param  {number} _height height of the rendering
	 * @param  {number} _gap    width of the gap between columns
	 */
	calculate(_section, _width, _height, _gap, _goUpdate = true){

		var divisor = 1;
		var gap = _gap || 0;

		//-- Check the width and create even width columns
		// var fullWidth = Math.floor(_width);
		var width = _width;
		var height = _height;

		var section = Math.floor(width / 12);

		var columnWidth;
		var spreadWidth;
		var pageWidth;
		var delta;

		if ( !this._isVerticalMode && ((this._minSpreadWidth === "auto" && this._spread) || (typeof this._minSpreadWidth === "number" && (width >= this._minSpreadWidth))) ) {
			divisor = 2;
		} else {
			divisor = 1;
		}

		//adjust reflowable book center page
		if((this.name !== "pre-paginated" || !_goUpdate) && _section && ((this.name === "reflowable" && _section.index === 0) || _section.properties.includes("page-spread-center") || _section.properties.includes("rendition:page-spread-center") || _section.properties.includes("page-spread-center-left") || _section.properties.includes("page-spread-center-right"))){
			divisor = 1;
		}

		/*if(divisor === 2 && _section && _section.document){
			let imgCount = $("img, svg", _section.document).length;
			let bodyInnerText = $("body", _section.document).text().trim();
			if(imgCount === 1 && bodyInnerText === ""){
				divisor = 1;
			}
		}*/
		
		if (this.name === "reflowable" && this._flow === "paginated" && !(_gap >= 0)) {
			gap = ((section % 2 === 0) ? section : section - 1);
		}

		if (this.name === "pre-paginated" ) {
			gap = 0;
		}

		//-- Double Page
		if(divisor > 1) {
			// width = width - gap;
			// columnWidth = (width - gap) / divisor;
			// gap = gap / divisor;

			/*if (this.name === "pre-paginated" ) {
				if((width/2)%2 !== 0){
					let calcWidth = width, keepCalc = true;
					while(keepCalc){
						calcWidth -= 1;
						if((calcWidth/2)%2 === 0){
							keepCalc = false;
							columnWidth = (calcWidth / divisor) - gap;
						}
					}
				}else{
					columnWidth = (width / divisor) - gap;
				}
			}else{
				columnWidth = (width / divisor) - gap;
			}*/
			columnWidth = (width / divisor) - gap;
			pageWidth = columnWidth + gap;
		} else {
			columnWidth = width;
			pageWidth = width;
		}

		if (this.name === "pre-paginated" && divisor > 1) {
			width = columnWidth;
		}

		spreadWidth = (columnWidth * divisor) + gap;

		delta = width;

		if(_goUpdate){

			this.width = width;
			this.height = height;
			this.spreadWidth = spreadWidth;
			this.pageWidth = pageWidth;
			this.delta = delta;

			this.columnWidth = columnWidth;
			this.gap = gap;
			this.divisor = divisor;

			// this.props.width = width;
			// this.props.height = _height;
			// this.props.spreadWidth = spreadWidth;
			// this.props.pageWidth = pageWidth;
			// this.props.delta = delta;
			//
			// this.props.columnWidth = colWidth;
			// this.props.gap = gap;
			// this.props.divisor = divisor;

			this.update({
				width,
				height,
				spreadWidth,
				pageWidth,
				delta,
				columnWidth,
				gap,
				divisor
			}, false);

		} else {
			return {
				width,
				height,
				spreadWidth,
				pageWidth,
				delta,
				columnWidth,
				gap,
				divisor
			};
		}

	}

	/**
	 * Switch between using spreads or not, and set the
	 * width at which they switch to single.
	 * @param  {string} spread "none" | "always" | "auto"
	 * @param  {number} min integer in pixels
	 * @return {boolean} spread true | false
	 */
	 spread(spread, min, emitLayoutUpdate = true) {

		if (spread) {
			let axis = (typeof spread === "string" && spread.indexOf("vertical") === 0) ? "vertical" : "horizontal";
			if(axis === "vertical"){
				this._spread = (spread.replace("vertical_", "") === "none") ? false : true;
				this._isVerticalMode = true;
			}else{
				this._spread = (spread === "none") ? false : true;
				this._isVerticalMode = false;
			}

			this.update({spread: this._spread}, emitLayoutUpdate);
		}

		if (min && min >= 0) {
			this._minSpreadWidth = min;
		}

		return this._spread;
	}

	/**
	 * Apply Css to a Document
	 * @param  {Contents} contents
	 * @return {Promise}
	 */
	 format(contents, section, axis){
		var formating;
		if (this.name === "pre-paginated") {
			let stageSize = this._rendition.manager.stage.size();
			let result = this.calculate(section, stageSize.width, stageSize.height, null, false);
			if(this._isWebToon && !this._spread && this._rendition.manager.name === "continuous"){
				//條漫單頁滾動瀏覽
				formating = contents.webToon(result.columnWidth, result.height, section, result.divisor);
			}else{
				if(this._rendition.settings.isDomTriggerByTouch){
					//app, mweb
					if(this._isWebToon){
						//條漫雙拼, 翻頁模式
						formating = contents.fit(result.columnWidth, result.height, section, result.divisor);
					}else{
						if(this._rendition.manager.name === "continuous"){
							if(!this._spread){
								//固定版單頁滾動瀏覽
								formating = contents.webToon(result.columnWidth, result.height, section, result.divisor);
							}else{
								//固定版雙拼滾動瀏覽
								formating = contents.webToon(result.columnWidth, result.height, section, result.divisor, true);
							}
						}else{
							//固定版翻頁模式
							formating = contents.fit(result.columnWidth, result.height, section, result.divisor);
						}
					}
				}else{
					//web版
					formating = contents.fit(result.columnWidth, result.height, section, result.divisor);
				}
			}
		} else if (this._flow === "paginated") {
			formating = contents.columns(this.width, this.height, this.columnWidth, this.gap, this.settings.direction);
		} else if (axis && axis === "horizontal") {
			formating = contents.size(null, this.height);
		} else {
			formating = contents.size(this.width, null);				
		}

		return formating; // might be a promise in some View Managers
	}

	/**
	 * Count number of pages
	 * @param  {number} totalLength
	 * @param  {number} pageLength
	 * @return {{spreads: Number, pages: Number}}
	 */
	count(totalLength, pageLength) {

		let spreads, pages, minTextSize;

		if (this.name === "pre-paginated") {
			spreads = 1;
			pages = 1;
		} else if (this._flow === "paginated") {
			pageLength = pageLength || this.delta;
			//spreads = Math.ceil( totalLength / pageLength);
			minTextSize = this._rendition.themes._booksFontSize * this._rendition.themes._booksLineHeight;
			spreads =  (Math.round(totalLength)%pageLength >= minTextSize) ? Math.ceil( totalLength / pageLength ) : Math.floor( totalLength / pageLength );
			pages = spreads * this.divisor || 1;
		} else { // scrolled
			pageLength = pageLength || this.height;
			spreads = Math.ceil( totalLength / pageLength);
			pages = spreads;
		}

		return {
			spreads,
			pages
		};

	}

	/**
	 * Update props that have changed
	 * @private
	 * @param  {object} props
	 */
	 update(props, emitLayoutUpdate = true) {
		// Remove props that haven't changed
		Object.keys(props).forEach((propName) => {
			if (this.props[propName] === props[propName]) {
				delete props[propName];
			}
		});

		if(Object.keys(props).length > 0) {
			let newProps = extend(this.props, props);
			if(emitLayoutUpdate){
				this.emit(EVENTS.LAYOUT.UPDATED, newProps, props);
			}
		}
	}
}

export default ExLayout;